import { NotificationsObservable } from '../../../core/notifications-observable/implementation';
import { Notification } from '../../../core/notification/implementation';
import { ExtractObserverNameAndCallback } from '../../../core/notifications-observer/functions';
import { EVENTS_OBSERVABLE_PRIVATE } from './privates';
import { ConstructEventsObservable } from './constructor';
export function EventsObservableOnObserved(instance, observer) {
    const privates = instance[EVENTS_OBSERVABLE_PRIVATE];
    const name = privates.name;
    const nameAndCallback = ExtractObserverNameAndCallback(observer);
    if (nameAndCallback === null) {
        if (name === null) {
            throw new TypeError(`Cannot observe an EventsObservable without a name (null), with a standard Observer (use a NotificationsObserver instead).`);
        }
        else {
            const listener = (event) => {
                observer.emit(new Notification(name, event));
            };
            privates.observerListenerMap.set(observer, listener);
            privates.target.addEventListener(name, listener);
        }
    }
    else {
        if ((privates.name !== null) && (nameAndCallback.name !== name)) {
            throw new TypeError(`Cannot observe an EventsObservable (${name}), with a NotificationsObserver having a different name (${nameAndCallback.name}).`);
        }
        else {
            privates.target.addEventListener(nameAndCallback.name, nameAndCallback.callback);
        }
    }
}
export function EventsObservableOnUnobserved(instance, observer) {
    const privates = instance[EVENTS_OBSERVABLE_PRIVATE];
    const name = privates.name;
    const nameAndCallback = ExtractObserverNameAndCallback(observer);
    if (nameAndCallback === null) {
        if (name === null) {
            throw new TypeError(`Cannot unobserve an EventsObservable without a name (null), with a standard Observer (use a NotificationsObserver instead).`);
        }
        else {
            privates.target.removeEventListener(name, privates.observerListenerMap.get(observer));
            privates.observerListenerMap.delete(observer);
        }
    }
    else {
        if ((name !== null) && (nameAndCallback.name !== name)) {
            throw new TypeError(`Cannot unobserve an EventsObservable (${name}), with a NotificationsObserver having a different name (${nameAndCallback.name}).`);
        }
        else {
            privates.target.removeEventListener(nameAndCallback.name, nameAndCallback.callback);
        }
    }
}
export function EventsObservableGetTarget(instance) {
    return instance[EVENTS_OBSERVABLE_PRIVATE].target;
}
export function EventsObservableGetName(instance) {
    return instance[EVENTS_OBSERVABLE_PRIVATE].name;
}
export const EventsObservable = class EventsObservable extends NotificationsObservable {
    constructor(target, name = null) {
        super(() => {
            return {
                onObserved: (observer) => {
                    EventsObservableOnObserved(this, observer);
                },
                onUnobserved: (observer) => {
                    EventsObservableOnUnobserved(this, observer);
                }
            };
        });
        ConstructEventsObservable(this, target, name);
    }
    get target() {
        return EventsObservableGetTarget(this);
    }
    get name() {
        return EventsObservableGetName(this);
    }
};
//# sourceMappingURL=implementation.js.map